import React from 'react';
import PropTypes from 'prop-types';
import BaseHeader from './BaseHeader';
import BaseBody from './BaseBody';
import classnames from 'classnames';
import { KeyCode, DateUtil } from '../util';

const YEAR_PREV_NEXT_CHANGE_NUM = 10;

function YearHeader(props){
    const {
        startYear,
        endYear,
        onPrevDecade,
        onNextDecade,
        onDecadeClick,
    } = props;

    return (
        <BaseHeader onSuperPrev={onPrevDecade} onSuperNext={onNextDecade}>
            <button onClick={onDecadeClick}>
                {`${startYear} - ${endYear}`}
            </button>
        </BaseHeader> 
    );
}

function YearBody(props){
    const { viewDate, renderCellContent } = props;
    let titleStartYear = DateUtil.getYearShowStart(viewDate);
    let bodyStartYear = DateUtil.addYear(titleStartYear, -1);

    return (
        <BaseBody 
            {...props} 
            rowNum={DateUtil.DEFAULT_PANEL_BODY_TABLE_ROW_NUM} 
            colNum={DateUtil.DEFAULT_PANEL_BODY_TABLE_COL_NUM}
            firstShowDate={bodyStartYear}
            renderCellContent={renderCellContent || DateUtil.getYear}
            calculateCellDate={DateUtil.addYear}
        />
    );
}

class YearPanel extends React.Component {
    handleYearSelect = (date, event) => {
        const { onChange, picker, onSelect, onPanelChange } = this.props;
        onSelect?.(date, 'year');
        if(picker === 'year'){
            onChange?.(date, event);
        } else {
            onPanelChange?.(picker === 'month' ? 'month' : 'date', date);
        }
    }

    handleDecadeChange = diff => {
        const { viewDate, onPanelChange } = this.props;
        let newDate = DateUtil.addYear(viewDate, diff);
        onPanelChange?.('year', newDate);
    }

    onKeyDown = e => {
        const { onPanelChange, viewDate, onSelect, onChange } = this.props;
        // console.log('年面板的按键事件', e.keyCode);
        let newDate = viewDate;
        switch(e.keyCode){
            case KeyCode.LEFT:
                newDate = DateUtil.addYear(viewDate, -1);
                onSelect?.(newDate, 'year');
                break;
            case KeyCode.UP:
                newDate = DateUtil.addYear(viewDate, -DateUtil.DEFAULT_PANEL_BODY_TABLE_COL_NUM);
                onSelect?.(newDate, 'year');
                break;
            case KeyCode.RIGHT:
                newDate = DateUtil.addYear(viewDate, 1);
                onSelect?.(newDate, 'year');
                break;
            case KeyCode.DOWN:
                newDate = DateUtil.addYear(viewDate, DateUtil.DEFAULT_PANEL_BODY_TABLE_COL_NUM);
                onSelect?.(newDate, 'year');
                break;
            case KeyCode.ENTER:
                onSelect?.(newDate, 'year');
                onChange?.(newDate, e);
                break;
            default: 
                return true;
        }
        e.preventDefault();
        if(!DateUtil.isSame(newDate, viewDate, 'decade')){
            onPanelChange?.('year', newDate);
        }
        return false;
    }

    render() {
        const {
            viewDate,
            onPanelChange,
            superNext,
            superPrev,
            panelWrapperProps,
            ...other
        } = this.props;

        let startYear = DateUtil.getYearShowStart(viewDate).getFullYear();
        let endYear = startYear + 9; 
        return (
            <div
                className={classnames({
                    "picker-panel-content": true,
                    "picker-year-panel": true,
                })}
                {...panelWrapperProps}
            >
                <YearHeader 
                    startYear={startYear} 
                    endYear={endYear}
                    onPrevDecade={superPrev && this.handleDecadeChange.bind(this, -YEAR_PREV_NEXT_CHANGE_NUM)} 
                    onNextDecade={superNext && this.handleDecadeChange.bind(this, YEAR_PREV_NEXT_CHANGE_NUM)} 
                    onDecadeClick={() => onPanelChange('decade', viewDate)}
                />
                <YearBody 
                    {...other}
                    viewDate={viewDate} 
                    startYear={startYear} 
                    onSelect={this.handleYearSelect}
                />
            </div>
        );
    }
}

YearPanel.PropTypes = {
    picker: PropTypes.string,
    superPrev: PropTypes.bool,
    superNext: PropTypes.bool,
    viewDate: PropTypes.object, // Date类型
    onPanelChange: PropTypes.func,
    onChange: PropTypes.func,
    onSelect: PropTypes.func,
    onDateMouseEnter: PropTypes.func,
    onDateMouseLeave: PropTypes.func,
};

export default YearPanel;